import { TypedObject } from "@multiweb/types/react";
import { WorkflowEditorProps } from "../../../../../types";

export type ActionPageProps = {
    readonly properties: TypedObject<string>;
    readonly updateAction: (valueKeyPairs: readonly { key: string; value: string }[]) => void;
} & WorkflowEditorProps;

export type TriggerPageProps = {
    readonly properties: TypedObject<string>;
    readonly updateTrigger: (valueKeyPairs: readonly { key: string; value: string }[]) => void;
} & WorkflowEditorProps;
